import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Modal from 'styled-react-modal';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { useTranslations } from '@lang';
import { Button } from '@common/components';

import { modalErrorHide } from '@store/modalError/actions';
import { modalErrorSelectors } from '@store/modalError/selectors';

const ModalWrapper = styled.div`
  padding: 24px;
  background: #fff;
  box-shadow: 0px 10px 30px #00000026;
  border: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  border-radius: 3px;
  max-width: 560px;
  width: 100%;
  font-size: 16px;
`;

const ActionButtons = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: flex-end;
`;

export const ErrorModal = ({ error = null, modalErrorHide, preventPageReload = false }) => {
  const { t } = useTranslations();

  return (
    <Modal isOpen={!!error}>
      <ModalWrapper>
        {!!error && t(`error.${error.code}`, { ...error })}
        <ActionButtons>
          <Button isPrimary isSmall onClick={(e) => modalErrorHide(e, preventPageReload)}>
            {t('modalError.confirm')}
          </Button>
        </ActionButtons>
      </ModalWrapper>
    </Modal>
  );
};
ErrorModal.propTypes = {
  error: PropTypes.shape({
    errorMessage: PropTypes.string,
    code: PropTypes.string,
  }),
  modalErrorHide: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: modalErrorSelectors.getModalError(state),
  preventPageReload: modalErrorSelectors.getModalErrorPreventPageReload(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      modalErrorHide,
    },
    dispatch
  );

const ErrorModalContainer = connect(mapStateToProps, mapDispatchToProps)(ErrorModal);

export default ErrorModalContainer;
